import ApiService from "../api";

export default class LogService extends ApiService {

    constructor() {
        super("/api/logs");
    }

    listaPaginada(filtros = {}, pageable = {}) {
        const {
            usuario,
            dashboard,
            tipo,
            dataInicio,
            dataFim
        } = filtros;

        const {
            page = 0,
            size = 10,
            sortKey = "data",
            sortDirection = "desc",
        } = pageable;

        const params = new URLSearchParams();

        if (usuario) params.append("usuario", usuario);
        if (dashboard) params.append("dashboard", dashboard);
        if (tipo) params.append("tipo", tipo);
        if (dataInicio) params.append("dataInicio", dataInicio);
        if (dataFim) params.append("dataFim", dataFim);

        params.append("page", page);
        params.append("size", size);

        if (sortKey && sortDirection) {
            params.append("sort", `${sortKey},${sortDirection}`);
        }

        const url = `?${params.toString()}`;
        return this.get(url);
    }

    obterFiltros() {
        return this.get("/filtros");
    }

    buscarLogPorModulo(modulo) {
        const params = new URLSearchParams();
        if (modulo) params.append('modulo', modulo);
        return this.get(`/modulo?${params.toString()}`)
    }

    gerarLogAcesso(data) {
        return this.post('/', data)
    }
}